import { PerformanceTracking } from '@shared/tracking';
import { storeFreeze } from 'ngrx-store-freeze';

import { Action } from './actions';
import { Reducer } from './store';

export function storeFreezeReducerFactory(
  performanceTracking: PerformanceTracking,
) {
  return (reducer: Reducer<any>) => {
    const storeFreezeFn = storeFreeze(reducer);
    return (state: any, action: Action) => {
      performanceTracking.mark('store-freeze-start');
      const next = storeFreezeFn(state, action);
      performanceTracking.mark('store-freeze-end');
      performanceTracking.measure(
        'store-freeze',
        'store-freeze-start',
        'store-freeze-end',
      );
      return next;
    };
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/ko/webapp/src/app/@shared/datastore/store-freeze.reducer.ts